import { FormControlLabel, Switch } from '@mui/material'
import { React } from 'react'

const switchStyle = () => {
  return {
    '& .MuiSwitch-switchBase': {},

    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(24px)',
      color: 'default-background.main',
      '& + .MuiSwitch-track': {
        backgroundColor: 'alternate.main',
        opacity: 1,
        border: 0,
      },
      '& + .MuiTypography-root': {
        color: 'alternate.main',
      },
    },

    '& .MuiSwitch-thumb': {
      width: '18px',
      height: '18px',
      marginTop: '5px',
      marginLeft: '5px',
    },

    '& .MuiSwitch-track': {
      borderRadius: '13px',
    },

    width: '70px',
    height: '46px',
    boxSizing: 'border-box',
  }
}

const AdxSwitch = ({ label1, label2, state, onChange, onClick, sx, placement, ...rest }) => {
  if (label1 && label2) {
    return (
      <FormControlLabel
        label={state ? label1 : label2}
        labelPlacement={placement ? placement : 'start'}
        componentsProps={{
          typography: {
            color: state ? 'alternate.main' : 'dark-text.main',
          },
        }}
        control={
          <Switch
            onClick={onClick}
            sx={{ ...switchStyle(), ...sx }}
            checked={state}
            disableRipple
            onChange={onChange}
            {...rest}
          />
        }
      />
    )
  }

  return (
    <Switch
      onClick={onClick}
      sx={{ ...switchStyle() }}
      checked={state}
      disableRipple
      onChange={onChange}
    />
  )
}

export default AdxSwitch
